import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppChat = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [phone, setPhone] = useState("905301109383"); // API gelene kadar yedek numara

  useEffect(() => {
    // Backend'de bu numara herkese açık bir endpoint'te olmalı (Auth gerekmez)
    const fetchPhone = async () => {
      try {
        const res = await axios.get("https://api.pinkhomebalat.com/api/public/whatsapp");
        if (res.data.whatsapp_num) {
          setPhone(res.data.whatsapp_num);
        }
      } catch (err) {
        console.error("WP numarası çekilemedi, varsayılan kullanılıyor.");
      }
    };
    fetchPhone();
  }, []);

  const handleSend = () => {
    if (message.trim() !== "") {
      window.open(
        `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
        "_blank"
      );
      setMessage("");
    }
  };

  return (
    <>
      {open && (
        <div style={{
          position: "fixed", bottom: "90px", right: "20px", width: "300px",
          height: "400px", backgroundColor: "#ECE5DD", borderRadius: "10px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.3)", zIndex: 1000,
          display: "flex", flexDirection: "column", overflow: "hidden", fontFamily: "Arial, sans-serif"
        }}>
          {/* Başlık */}
          <div style={{
            display: "flex", alignItems: "center", padding: "10px",
            backgroundColor: "#25D366", color: "#fff", fontWeight: "bold"
          }}>
            <FaWhatsapp size={20} style={{ marginRight: "8px" }} />
            Pink home
          </div>

          {/* Mesaj Alanı */}
          <div style={{ flex: 1, padding: "10px", display: "flex", flexDirection: "column", overflowY: "auto", gap: "5px" }}>
            <div style={{
              backgroundColor: "#fff", padding: "8px", borderRadius: "10px",
              alignSelf: "flex-start", maxWidth: "80%", fontSize: "14px"
            }}>
              {message || "Merhaba, sizlere nasıl yardımcı olabiliriz?"}
            </div>
          </div>

          {/* Mesaj Yazma */}
          <div style={{ display: "flex", borderTop: "1px solid #ccc" }}>
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Mesaj yazın..."
              style={{ flex: 1, padding: "10px", border: "none", outline: "none", backgroundColor: "#f0f0f0" }}
            />
            <button onClick={handleSend} style={{ backgroundColor: "#25D366", color: "#fff", border: "none", padding: "10px", cursor: "pointer" }}>
              Gönder
            </button>
          </div>
        </div>
      )}

      {/* Chat Butonu */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          position: "fixed", width: "60px", height: "60px", bottom: "30px", right: "30px",
          backgroundColor: "#25D366", color: "#fff", borderRadius: "50%", border: "none",
          fontSize: "30px", boxShadow: "2px 2px 5px #999", zIndex: 1000, cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center"
        }}
      >
        <FaWhatsapp size={40}/>
      </button>
    </>
  );
};

export default WhatsAppChat;